import { dxtToLocalServerTime } from "@dexteel/mesf-core";
import { Tooltip } from "@mui/material";
import type { ReactElement } from "react";
import type { StrandLoss } from "../../types/strand-loss";
import styles from "../other/tooltip.module.css";

const DATE_TIME_FORMAT = "HH:mm:ss";
const EMPTY_DETAIL = "Not specified";

interface StrandLossTooltipProps {
  loss: StrandLoss;
  fontFamily: string;
  fontSize: string;
  children: ReactElement;
}

export const StrandLossTooltipContent = ({ loss }: { loss: StrandLoss }) => {
  const reason = loss.DelayCodeName?.trim() || EMPTY_DETAIL;
  const comments = loss.Comments?.trim() || EMPTY_DETAIL;
  const from = dxtToLocalServerTime(loss.Start, DATE_TIME_FORMAT);
  const to = dxtToLocalServerTime(loss.End, DATE_TIME_FORMAT);

  return (
    <div className={styles.tooltipDefaultContainer}>
      <p>
        <b>Strand #{loss.Strand}</b>
      </p>
      <p>
        <b>Duration: {loss.Duration}</b>
      </p>
      <p>Reason: {reason}</p>
      <p>Comments: {comments}</p>
      <p className={styles.tooltipDefaultContainerParagraph}>
        {`From: ${from} to: ${to}`}
      </p>
    </div>
  );
};

export const StrandLossTooltip = ({
  loss,
  fontFamily,
  fontSize,
  children,
}: StrandLossTooltipProps) => (
  <Tooltip
    describeChild
    followCursor
    placement="top"
    title={<StrandLossTooltipContent loss={loss} />}
    slotProps={{
      tooltip: {
        sx: {
          backgroundColor: "transparent",
          color: "common.black",
          fontFamily,
          fontSize,
          maxWidth: "none",
          padding: 0,
        },
      },
    }}
  >
    {children}
  </Tooltip>
);
